

import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import notify from '../../../utils/notification';
import { exportToExcel, exportVerifiedToExcel } from '../../../utils/exportToExcel';
import { getOrganisationListForExcel } from '../../../services/adminApiService/organisationApi/OrganisationApiService';

const DownloadExcelButton = ({ data,
    headers,
    fileName,
    userId,
    searchValue,
    selectedDistrictId,
    selectedSubCategoryId,
    selectedSportId,
     btnName, onClick }) => {
  const [isLoading, setIsLoading] = useState(false);


    const handleDataToExcel = async () => {
        try {
            setIsLoading(true);

            const response = await getOrganisationListForExcel(
                userId,
                searchValue,
                selectedDistrictId,
                selectedSubCategoryId,
                selectedSportId
            );

            const apiData = response.data;

            if (Number(userId) === 2) {
                exportVerifiedToExcel(apiData, "InstitutionListVerified.csv");
            } else {
                exportVerifiedToExcel(apiData, "IndividualListVerified.csv");
            }

        } catch (error) {
            console.error('Excel download error:', error);
        } finally {
            setIsLoading(false);  // stop loading after download
        }
    };

  const handleClick = async () => {
  
  
    try {
      setIsLoading(true);
       if (userId) {
            await handleDataToExcel();
            return
        }

      let finalData;
      
      if (onClick) {
        // Case 2: fetch + export
        finalData = await onClick();
      } else {
        // Case 1: direct export from state
        finalData = data?.data || data;
      }
       
      //  // ✅ Check if data exists or is empty
      if (finalData.length === 0) {
       notify("error", "No Data found for Donwload");
        // toast.warning("No data available to download."); // or use alert()
        // alert("No data available to download.");
        return;
      }

      exportToExcel(finalData, headers, fileName);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    } finally {
      setIsLoading(false);
    }
  };


    // const handleClick = async () => {
            
    //     if (userId) {
    //         await handleDataToExcel();
    //         return
    //     }
    //     setIsLoading(true);
    //         exportToExcel(data, headers, fileName);
    //         setIsLoading(false);
    // };
    
  return (
        <Button
            variant="primary"
            onClick={handleClick}
            disabled={isLoading}
        >
            {isLoading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                    />
                    Downloading...
                </>
            ) : (
                <>
                    Download Excel <i className="fa fa-download"></i>
                </>
            )}
        </Button>
    );
};

export default DownloadExcelButton;
